import Environment from '../../../environment';
import {getLocalStorage} from '@/Utils/CommonUtils';

const onFulfilled = async (config: any) => {
  // TODO: maybe don't access localstorage on every api request?
  const token = await getLocalStorage('access_token');
  if (!config.headers) {
    config.headers = {
      ...config.headers,
      'Content-Type': 'application/json',
    };
  }
  if (token && !config.headers?.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.baseURL === Environment.TOURNAMENT_API_URL && !config.headers['api-key']) {
    config.headers['api-key'] = Environment.X_API_KEY; // Replace with the actual API key
  } else if ((!config.headers || !("api-key" in config.headers))) {
    config.headers['api-key'] = Environment.API_KEY;
  }
  
  return config;
};

export {onFulfilled};
